import React from "react";
import _ from "lodash";
import Image from "../ImageElement";
import PropTypes from "prop-types";
import "../../css/Cards/Card.css";
import ChevronRight from "../../svg/ICON_chevronRight_Dark.svg";

/**
 * Card component
 */
class Card extends React.Component {
  static displayName = "Card";
  static propTypes = {
    className: PropTypes.string,
    modifier: PropTypes.string,
    card: PropTypes.object,
    children: PropTypes.node,
    title: PropTypes.string,
    linkType: PropTypes.oneOf(["btn", "a"]),
    screen: PropTypes.string.isRequired,
    image: PropTypes.object,
    portrait: PropTypes.bool,
  };
  static defaultProps = {
    linkType: "btn",
    portrait: false,
  };

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Card";

    this.classModifier = this.className;
    if (props.modifier)
      this.classModifier = `${this.className}--${props.modifier}`;
  }

  /**
   * @override
   */
  render() {
    let classModifier = "";
    if ((this.props.card && this.props.card.isFull()) || this.props.isFull) {
      classModifier += " full";
    }

    let content = this.props.children;
    if (this.props.card) {
      content = this.props.card.exerpt;
    }

    let image = null;
    if (this.props.card) {
      image = this.props.portrait
        ? this.props.card.imagePortrait()
        : this.props.card.imageLandscape();
    } else if (this.props.image) {
      image = this.props.image;
    }
    return (
      <div
        className={`${this.classModifier}${classModifier} ${
          this.props.className || ""
        }`}
      >
        <div className={`${this.className}__title`}>
          {this.props.title || this.props.card.get("title")}
        </div>
        <div className={`${this.className}__content`}>
          {!_.isNil(image) && image.width > 0 && (
            <div className={`${this.className}__img`}>
              <Image src={image[`${this.props.screen}_src`]} alt={image.alt} />
            </div>
          )}
          <div className={`${this.className}__text`}>
            {_.isString(content) ? (
              <div
                className={`${this.className}__html`}
                dangerouslySetInnerHTML={{
                  __html: content,
                }}
              />
            ) : (
              <div className={`${this.className}__html`}>{content}</div>
            )}

            {this.props.card && this.props.card.href && (
              <div
                className={`${this.className}__link--${this.props.linkType}`}
              >
                <a href={this.props.card.href}>
                  {this.props.card.button}
                  <img src={ChevronRight} className="icon" alt=">" />
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/Cards/Card.js